export const checkErrorResponseFormat = (error) => {
  if (error.response) {
    return error.response.data;
  }
  if (error.message) {
    return error;
  }
  return { message: "error status " + error.status };
};
